import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { NAV_LINKS, COMPANY } from '../constants/data';
import styles from './Navbar.module.css';

export default function Navbar() {
  const [scrolled,  setScrolled]  = useState(false);
  const [menuOpen,  setMenuOpen]  = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => { setMenuOpen(false); }, [pathname]);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [menuOpen]);

  const close = () => setMenuOpen(false);

  return (
    <>
      <nav className={`${styles.nav} ${scrolled ? styles.scrolled : ''}`}>

        {/* ── LOGO ── */}
        <Link to="/" className={styles.logo} onClick={close}>
          <img
            src={`${process.env.PUBLIC_URL}/logo-symbol.png`}
            alt="EMK Asansör"
            className={styles.logoImg}
          />
          <div className={styles.logoText}>
            <div className={styles.logoName}>EMK ASANSÖR</div>
            <div className={styles.logoTag}>{COMPANY.slogan}</div>
          </div>
        </Link>

        {/* ── Desktop ── */}
        <div className={styles.desktopLinks}>
          {NAV_LINKS.map(({ label, path }) => (
            <Link key={path} to={path}
              className={`${styles.navLink} ${pathname === path ? styles.active : ''}`}>
              {label}
            </Link>
          ))}
          <Link to="/iletisim" className={styles.btnTeklif}>Teklif Al</Link>
        </div>

        {/* ── Hamburger ── */}
        <button
          className={`${styles.hamburger} ${menuOpen ? styles.open : ''}`}
          onClick={() => setMenuOpen(v => !v)}
          aria-label="Menüyü aç/kapat"
          aria-expanded={menuOpen}
        >
          <span /><span /><span />
        </button>
      </nav>

      {menuOpen && (
        <div className={styles.mobileOverlay} onClick={close} aria-hidden="true" />
      )}

      <div className={styles.mobileMenu} data-open={menuOpen} aria-hidden={!menuOpen}>
        {/* Mobil menü logosu */}
        <div className={styles.mobileLogo}>
          <img src={`${process.env.PUBLIC_URL}/logo-symbol.png`} alt="EMK Asansör" className={styles.mobileLogoImg} />
          <div>
            <div className={styles.logoName}>EMK ASANSÖR</div>
            <div className={styles.logoTag}>{COMPANY.slogan}</div>
          </div>
        </div>

        <nav className={styles.mobileLinks}>
          {NAV_LINKS.map(({ label, path }) => (
            <Link key={path} to={path} onClick={close}
              className={`${styles.mobileLink} ${pathname === path ? styles.mobileLinkActive : ''}`}>
              {label}
            </Link>
          ))}
        </nav>

        <Link to="/iletisim" className={styles.mobileTeklif} onClick={close}>
          Ücretsiz Teklif Al
        </Link>

        <div className={styles.mobileContact}>
          <a href={`tel:${COMPANY.phone}`} className={styles.mobileContactItem} onClick={close}>
            <span>📞</span> {COMPANY.phone}
          </a>
          <a href={`tel:${COMPANY.mobile.replace(/\s/g, '')}`} className={styles.mobileContactItem} onClick={close}>
            <span>📱</span> {COMPANY.mobile}
          </a>
          <a href={`mailto:${COMPANY.email}`} className={styles.mobileContactItem} onClick={close}>
            <span>📧</span> {COMPANY.email}
          </a>
        </div>
      </div>
    </>
  );
}
